const style = () => ({
    display: "flex",
    flex: 1,
    height: "100%",
    form: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
    },
});

export default style;
